import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import themes from '../lib/themes';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';

const SuccessionQuestionnaireContainer = (props, railsContext) => {
  const initialState = {
    company: props.company || { 
      host: railsContext.company_host,
      features: railsContext.features,
      file_import_disclaimer: railsContext.file_import_disclaimer,
      name: railsContext.company_name,
      branded_name: railsContext.company_branded_name,
      short_name: railsContext.company_short_name,
      // Add marketplace theme settings if available
      primary_color: railsContext.primary_color,
      secondary_color: railsContext.secondary_color,
      neutral_color: railsContext.neutral_color,
      accent_color: railsContext.accent_color,
      background_color: railsContext.background_color,
    },
    user: props.current_user,
  };

  const store = configureStore({ ...props, company: initialState.company });

  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbSuccession',
  });

  const jss = create({
    ...jssPreset(),
  });

  const theme = themes[railsContext.theme_name];
  window.locale = railsContext.i18nLocale || 'en';

  return (
    <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbSuccession-">
      <MuiThemeProvider theme={createMuiTheme(theme)}>
        <CssBaseline />
        <Provider store={store}>
          <SnackbarProvider maxSnack={5}>
            <ApolloProvider client={client}>
              <SuccessionThemeProvider 
                company={initialState.company}
                user={props.current_user}
              >
                <div className="min-h-screen bg-succession-background">
                  {/* Questionnaire content will go here */}
                  <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <div className="px-4 py-6 sm:px-0">
                      <h1 className="text-2xl font-semibold text-succession-text">Succession Planning Questionnaire</h1>
                      <p className="mt-1 text-sm text-succession-text-secondary">
                        Please complete this questionnaire to help us understand your succession planning needs.
                      </p>
                    </div>
                  </div>
                </div>
              </SuccessionThemeProvider>
            </ApolloProvider>
          </SnackbarProvider>
        </Provider>
      </MuiThemeProvider>
    </JssProvider>
  );
};

export default SuccessionQuestionnaireContainer; 